<template>
  <a-modal :visible="true" title="新增部门" :width="930" :maskClosable="false" @ok="submit" @cancel="cancel"
    :confirm-loading="confirmLoading" :closable="false">
    <a-form-model ref="ruleForm" :model="form" :rules="rules">
      <a-form-model-item label="部门名称" prop="organizationName">
        <a-input v-model.trim="form.organizationName" style="width: 400px;" placeholder="请输入部门名称，不超过20个字"
          :maxLength="20" />
      </a-form-model-item>
      <a-form-model-item label="部门负责人">
        <div style="display: flex;justify-content: space-between;">
          <a-input v-model.trim="searchForm.account" placeholder="请输入账号" class="inputClass" />
          <a-input v-model.trim="searchForm.userName" placeholder="请输入姓名" style="margin-left: 20px;" class="inputClass" />
          <a-input v-model.trim="searchForm.phoneNumber" placeholder="请输入手机号" style="margin-left: 20px;"
            class="inputClass" />
          <a-button type="primary" @click="search" style="margin-left: 20px;" :loading="searchBtnLoading"
            :disabled="searchDisabled">
            <a-icon type="search" /> 查询
          </a-button>
        </div>

      </a-form-model-item>
    </a-form-model>
    <a-table :row-selection="{
      selectedRowKeys: table.selectedRowKeys,
      onChange: selectedStaff,
      type: 'radio',
    }" :columns="table.columns" :data-source="table.dataInfo" :pagination="false"
      :rowKey="(record, index) => record.userId" class="my-20" bordered style="margin-top: 20px" />
    <a-form-model-item style="margin-top: 20px;" label="" prop="account">
      <div style="display: flex;align-items: center;">
        <span> 账号：</span> <a-input style="width: 400px;" disabled v-model.trim="form.account"
          placeholder="请选择" />
      </div>

    </a-form-model-item>
    <a-form-model-item label="" prop="userName">
      <div style="display: flex;align-items: center;">
        <span>姓名：</span> <a-input style="width: 400px;" disabled v-model.trim="form.userName"
          placeholder="请选择" />
      </div>

    </a-form-model-item>
    <a-form-model-item label="" prop="phoneNumber">
      <div style="display: flex;align-items: center;">
        <span>手机号：</span> <a-input style="width: 400px;" disabled v-model.trim="form.phoneNumber"
          placeholder="请选择" />
      </div>

    </a-form-model-item>
    <a-form-model-item label="" prop="feishuid">
      <div style="display: flex;align-items: center;">
        <span>飞书open_id：</span> <a-input style="width: 400px;" v-model.trim="form.openId" placeholder=""
          class="inputClass" />
      </div>
    </a-form-model-item>

  </a-modal>
</template>

<script>
import { addStaffSearchForm, addStaffTableConfig } from '../../../help';
import * as api from '@/api/demandPoolShunyi';
import { SUCCESS_CODE } from '@/config';
export default {
  name: 'AddDepartment',
  computed: {
    searchDisabled() {
      return this.searchForm.account || this.searchForm.userName || this.searchForm.phoneNumber ? false : true;
    },
  },
  props: {
    // 是否显示
    showAddDepartment: {
      type: Boolean,
      default: false,
    },
    // 上级id
    parentOrganizationId: {
      type: String,
      default: '',
    },
  },
  watch: {
    parentOrganizationId: {
      handler(newVal) {
        if (newVal) this.form.parentOrganizationId = newVal;
      },
      immediate: true,
    },
  },
  data() {
    return {
      table: { ...addStaffTableConfig },
      confirmLoading: false, // 提交按钮loading
      form: {
        organizationName: '', // 新增组织名称
        parentOrganizationId: '', // 上级组织id
        principalId: '',// 组织负责人id
        phoneNumber: '',
        openId: '',
        userName: '',
        account: ''
      },
      searchForm: {
        ...addStaffSearchForm,
      },
      searchBtnLoading: false,
      rules: {
        organizationName: [{ required: true, message: '请输入组织名称', trigger: 'blur' }],
        userName: [{ required: false, message: '请输入名称', trigger: 'blur' }],
        phoneNumber: [{ required: false, message: '请输入手机号', trigger: 'blur' }],
        account: [{ required: false, message: '请输入账号', trigger: 'blur' }],
      },
    };
  },
  methods: {
    // 提交
    submit() {

      this.$refs.ruleForm.validate((valid) => {
        if (valid) {
          // if (!this.form.principalId) {
          //   this.$message.warning('请选择要添加部门负责人');
          //   return false;
          // }
          this.addDepartment();
        }
      });
    },
    // 取消
    cancel() {
      this.$emit('update:show-add-department', false);
    },
    /**网络请求 */
    // 添加部门
    async addDepartment() {
      try {
        this.confirmLoading = true;
        const result = await api.addDepartmentForDemandPool(this.form);
        this.confirmLoading = false;
        if (result.code === SUCCESS_CODE) {
          this.$message.success(result.msg);
          this.$emit('update:show-add-department', false);
          this.$emit('refreshDepartmentList');
        } else {
          this.$message.error(result.msg);
        }
      } catch (error) {
        console.log(error);
        this.confirmLoading = false;
      }
    },
    // 选中人员
    selectedStaff(items, selectedRows) {
      console.log(items, selectedRows);
      this.table.selectedRowKeys = items;
      this.form.principalId = selectedRows[0].userId;
      this.form.phoneNumber = selectedRows[0].phoneNumber
      this.form.openId = selectedRows[0].openId
      this.form.userName = selectedRows[0].userName
      this.form.account = selectedRows[0].account
      console.log(this.form);
    },
    // 查询
    search() {
      this.searchStaffInfo();
    },
    /**网络请求 */
    async searchStaffInfo() {
      try {
        this.searchBtnLoading = true;
        const result = await api.addStaffSearchStaffInfoForDemandPool(this.searchForm);
        this.searchBtnLoading = false;
        if (result.code === SUCCESS_CODE) {
          this.table.dataInfo = result.data;
        }
      } catch (error) {
        this.searchBtnLoading = false;
        console.log(error);
      }
    },
  },
  created() { },
};
</script>

<style lang="scss" scoped></style>
